import { GtmEventAction } from "@obg/gtm.types/adaptive";

export const DEPOSIT_SOURCE_TYPE_VALUE = "deposit";

export const DEPOSIT_SOURCE_TYPE_TRACKING_PAYLOAD = {
	SubArea: "Deposit Flow",
	ItemClicked: "Deposit Limits Calculator",
	GAEventName: "Payments",
	event: GtmEventAction.LinkClick,
};
